import { SlaMeasure } from "../../interfaces/Ticket";

export const fmtPercent = (p: number | null | undefined) =>
  p == null ? "—" : `${p.toLocaleString("pt-BR", { maximumFractionDigits: 1 })}%`;

export type SlaTone = "green" | "amber" | "red" | "none";

/** >=90 verde, >=70 âmbar, abaixo vermelho; sem base ("—") fica neutro. */
export const slaTone = (p: number | null | undefined): SlaTone =>
  p == null ? "none" : p >= 90 ? "green" : p >= 70 ? "amber" : "red";

export const TONE_TEXT: Record<SlaTone, string> = {
  green: "text-green-600 dark:text-green-400",
  amber: "text-amber-600 dark:text-amber-400",
  red: "text-red-600 dark:text-red-400",
  none: "text-gray-600 dark:text-gray-400",
};

export const TONE_BAR: Record<SlaTone, string> = {
  green: "bg-green-500",
  amber: "bg-amber-500",
  red: "bg-red-500",
  none: "bg-gray-300 dark:bg-white/20",
};

const MESES = ["jan", "fev", "mar", "abr", "mai", "jun", "jul", "ago", "set", "out", "nov", "dez"];

/** "2026-10" -> "out/26". */
export const labelMes = (ym: string) => {
  const [y, m] = ym.split("-");
  return `${MESES[Number(m) - 1] ?? m}/${y.slice(2)}`;
};

export const mesAtual = (now = new Date()) =>
  `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, "0")}`;

/** Mês corrente e os 11 anteriores, mais recente primeiro. */
export const ultimosMeses = (n = 12, now = new Date()): string[] =>
  Array.from({ length: n }, (_, i) => mesAtual(new Date(now.getFullYear(), now.getMonth() - i, 1)));

/** Contagens exibidas sob cada percentual. */
export const contagens = (m: SlaMeasure) => [
  { label: "No prazo", value: m.onTime },
  { label: "Atrasados", value: m.late },
  { label: "Em andamento", value: m.pending },
  { label: "Sem SLA", value: m.noSla },
];
